import { createSlice } from '@reduxjs/toolkit';

const ticketSlice = createSlice({
    name: "ticket",
    initialState: null,
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const ticketActions = ticketSlice.actions;
export default ticketSlice.reducer;